export default "__VITE_ASSET__Bq2MjU0T__"